<template>
    <div class="button-group">
        <b-button-group
            :id="`btn-talk-${button.event}-feedback`"
            v-for="button in buttons"
            :key="'button-' + button.event"
        >
            <b-button
                variant="primary"
                class="normal-btn"
                @click="$emit(button.event)"
            >
                {{ button.name }}
            </b-button>
            <b-button variant="primary" pressed @click="$emit(button.event)">
                <i class="fa" :class="[button.icon]" />
            </b-button>
        </b-button-group>
    </div>
</template>

<script>
export default {
    name: 'ActionGroup',
    data() {
        return {
            buttons: [
                {
                    event: 'request',
                    name: this.$t('stages.request'),
                    icon: 'fa-caret-down',
                },
                {
                    event: 'send',
                    name: this.$t('form.button.send'),
                    icon: 'fa-caret-up',
                },
            ],
        }
    },
}
</script>

<style lang="sass" scoped>
.button-group
    display: flex
    justify-content: flex-start
    align-items: center
    height: 30px
    .btn-group
        margin-right: 10px
        .btn-primary
            height: 32px
            display: flex
            justify-content: center
            align-items: center
            min-width: 100px
            &:focus
                box-shadow: none
        .normal-btn
            padding: 10px 25px
        .active
            min-width: auto
</style>
